import type { CrudAdapter } from '@botto/core';
import { useCrudDataSource } from '@botto/core';
import { tariffsApi } from '../client';
import type { Operator } from '../types';
import type { components } from '../generated/schema';

type OperatorCreate = components['schemas']['OperatorCreateRequest'];
type OperatorUpdate = components['schemas']['OperatorUpdateRequest'];

export const operatorsAdapter: CrudAdapter<Operator, OperatorCreate, OperatorUpdate> = {
  async list({ offset, limit, sortName, sortDirection }) {
    const { data, error } = await tariffsApi.GET('/operators/', {
      params: {
        query: {
          offset,
          limit,
          'sort.name': sortName ?? 'id',
          'sort.direction': (sortDirection ?? 'asc') as 'asc' | 'desc',
        },
      },
    });
    if (error) throw error;
    return { items: data?.items ?? [], total: data?.total ?? 0 };
  },
  async create(payload) {
    const { data, error } = await tariffsApi.POST('/operators/', { body: payload });
    if (error) throw error;
    return { id: (data as { id?: number } | undefined)?.id ?? 0 };
  },
  async update(payload) {
    const { data, error } = await tariffsApi.PUT('/operators/', { body: payload });
    if (error) throw error;
    return (data ?? payload) as unknown as Operator;
  },
  async byKey(id) {
    const { data, error } = await tariffsApi.GET('/operators/{operator_id}', {
      params: { path: { operator_id: Number(id) } },
    });
    if (error) throw error;
    return data as Operator;
  },
  async remove(id) {
    const { error } = await tariffsApi.DELETE('/operators/{operator_id}', {
      params: { path: { operator_id: Number(id) } },
    });
    if (error) throw error;
  },
};

export const operatorsStore = useCrudDataSource(operatorsAdapter);
